import React, { useEffect, useContext } from 'react';
import {
  Button,
  ButtonGroup,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Typography
} from '@one-thd/sui-atomic-components';
import proptypes from 'prop-types';
const { bool, func } = proptypes;
import { AddToContext } from '../../AddToContext';
import { SCREENS, TRACK } from '../../AddToConstants';
import { triggerAnalytics } from '../../AddToHelpers';

export const AbandonSelectionWarning = ({ handleClose, onConfirm, open }) => {
  const { screen } = useContext(AddToContext);

  useEffect(() => {
    if (open) {
      // 7.3 Copy from Your Lists Exit Overlay
      triggerAnalytics(TRACK.ADD_TO_LIST_COPY_LIST_EXIT_OVERLAY);
    }
  }, [open]);

  const onHandleClose = () => {
    if (screen === SCREENS.COPY_LIST_SUMMARY) {
      // 7.4 Copy from Your Lists Exit Overlay: Discard and Exit/Cancel
      triggerAnalytics(TRACK.ADD_TO_LIST_COPY_FROM_LISTS_EXIT_ACTION, { actionType: 'cancel button' });
    } else {
      // 7.8 Mini List Details Exit Overlay: Discard and Exit/Cancel
      triggerAnalytics(TRACK.ADD_TO_LIST_MINI_LIST_DETAILS_EXIT_ACTION, { actionType: 'cancel button' });
    }

    handleClose();
  };

  const handleOnConfirm = () => {
    if (screen === SCREENS.COPY_LIST_SUMMARY) {
      // 7.4 Copy from Your Lists Exit Overlay: Discard and Exit/Cancel
      triggerAnalytics(TRACK.ADD_TO_LIST_COPY_FROM_LISTS_EXIT_ACTION, {
        actionType: 'discard and exit button'
      });
    } else {
      // 7.8 Mini List Details Exit Overlay: Discard and Exit/Cancel
      triggerAnalytics(TRACK.ADD_TO_LIST_MINI_LIST_DETAILS_EXIT_ACTION, {
        actionType: 'discard and exit button'
      });
    }
    onConfirm();
  };

  if (!open) {
    return null;
  }

  return (
    <Modal open={open} onClose={handleClose}>
      <ModalHeader onClose={handleClose}>Are You Sure You Want to Exit?</ModalHeader>
      <ModalBody>
        <Typography data-testid="warning-abandon-message" variant="body-base">
          Exiting now will discard your current selections and you&apos;ll lose any progress
          you&apos;ve made. Are you sure you want to continue?
        </Typography>
      </ModalBody>
      <ModalFooter position="end">
        <ButtonGroup>
          <Button data-testid="warning-cancel" onClick={onHandleClose} variant="secondary">Cancel</Button>
          <Button data-testid="warning-exit" onClick={handleOnConfirm} variant="primary">Discard and Exit</Button>
        </ButtonGroup>
      </ModalFooter>
    </Modal>
  );
};

AbandonSelectionWarning.propTypes = {
  handleClose: func.isRequired,
  onConfirm: func.isRequired,
  open: bool.isRequired
};
